import { error as errorReducer } from './Error.reducer';
import {
    PAYINVOICES_RECEIVE,
    PAYINVOICES_ERROR,
    PAYINVOICES_DESCRIPTION_RECEIVE,
    PAYINVOICES_PAYMENT_STATUS,
} from '../Actions/PayInvoices.action';
import { PayInvoicesStep } from '../constants';

const defaultState = {
    errors: {},
    invoiceList: [],
    invoicesLoaded: false,
    payInvoicesDescription: '',
    paymentStatusText: '',
    paymentTransactionDate: '',
    paymentTransactionId: '',
    currentPaymentStep: PayInvoicesStep.List
};

export const invoicesToPay = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PAYINVOICES_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case PAYINVOICES_DESCRIPTION_RECEIVE:
            return {
                ...state,
                payInvoicesDescription: payload,
            };
        case PAYINVOICES_PAYMENT_STATUS:
            return {
                ...state,
                ...payload,
            };
        case PAYINVOICES_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
